import { type PropsWithChildren } from 'react';

import { VFlex, type VFlexProps } from '../VFlex';

const VStack = ({
  children,
  ref,
  ...rest
}: PropsWithChildren<Omit<VFlexProps, 'direction'>> &
  React.HTMLProps<HTMLDivElement> &
  React.RefAttributes<HTMLDivElement>) => {
  return (
    <VFlex ref={ref} {...rest} direction="col">
      {children}
    </VFlex>
  );
};

VStack.displayName = 'VStack';

export default VStack;
